import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import axios from "axios";
import * as Globals from "../Globals";
export function GetCategories() {
  axios.get(`${Globals.baseUrl}/Logging/GetCategories`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.LogGetCategories,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetSystemAuditLogs(cat1, cat2) {
  axios.post(
    `${Globals.baseUrl}/SystemAudit/GetAuditLogs`,
    { cat1: cat1.toString(), cat2: cat2.toString() },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.SystemAuditLogGetLogs,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
  });
}
